import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ChildDataService {
  embedded = signal(false);
}
